import {Storage} from "@/services/Storage"
import store from '../store'

export const authentication = {
    async isCashierLoggedIn() {
        let cashier = await Storage.getCurrentUser()
        await this.hasUsers()
        if (!!cashier) store.commit('setCurrentUser', cashier);
        return !!cashier;
    },

    hasUsers() {
        return Storage.getAllUsers().then(users => {
            if (!!users) {
                store.commit('setAllUsers', users);
            }
            return !!users;
        }).catch(() => false);
    },

    /**
     * Franchise Welcome session is valid only when persisted admin has
     * real credentials — empty `{}` after a partial wipe must not count.
     */
    isAdminLoggedIn: async () => {
        let adminUser = await Storage.getAdminUser();
        if (!adminUser || typeof adminUser !== 'object') return false;
        const email = adminUser.email || adminUser.Email || adminUser.username || adminUser.Username;
        const password = adminUser.password || adminUser.Password;
        return !!(
            email && String(email).trim().length > 0 &&
            password && String(password).trim().length > 0
        );
    },

    isStoreSelected() {
        return Storage.getDefaultStore().then((defaultStore) => {
            // Treat missing StoreDB as no selection so a stale nullish
            // row cannot force PIN after store-only sign-out.
            if (defaultStore && defaultStore.StoreDB) {
                store.commit('setDefaultStore', defaultStore)
                return true;
            }
            return false;
        }).catch(() => false)
    },

    isFloatSet(user) {
        return Storage.getFloat().then(res => {
            let userFloat = res.find(f => f.user.toLowerCase() === user.toLowerCase());
            return !!userFloat
        }).catch(() => false)
    },

    async isCurrentUserAdmin() {
        let user = await Storage.getCurrentUser();
        return user.Type.toLowerCase() === 'admin';
    }
}
